interface Props {
  time: number;
  color?: string;
  labelWhenFinished?: string;
  showSeconds?: boolean;
}

export const Timer = ({ time, color, labelWhenFinished, showSeconds = true }: Props) => {
  if (time < 0) {
    return labelWhenFinished;
  }
  const hours = Math.floor((time / (1000 * 60 * 60)) % 24);
  const minutes = Math.floor((time / 1000 / 60) % 60);
  const seconds = Math.floor((time / 1000) % 60);

  return (
    <span
      style={{
        color: color ? color : 'black',
      }}
    >
      {`${formatTime(hours)}:${formatTime(minutes)}${showSeconds ? `:${formatTime(seconds)}` : ''}`}
    </span>
  );
};

function formatTime(time: number): string {
  return time?.toString().padStart(2, '0').split('-').join('');
}
